import React from 'react';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';

interface Props extends IconButtonProps {
  isActive: boolean;
  children: React.ReactNode;
  onMouseDown: (e: any) => void;
}

function ButtonBase({ onMouseDown, isActive, children, ...restOfProps }: Props) {
  const classes = useStyles();

  return (
    <IconButton
      onMouseDown={onMouseDown}
      className={classNames(classes.root, { [classes.active]: isActive })}
      {...restOfProps}
    >
      {children}
    </IconButton>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 4,
    marginRight: theme.spacing(0.5),
  },
  active: {
    backgroundColor: theme.palette.grey[700],
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.common.black,
      backgroundColor: theme.palette.grey[400],
    },
  },
}));

export default ButtonBase;
